import React from 'react';
import CrmWhatsappConversations from './CrmWhatsappConversations';

const CrmWhatsappDialog = ({ target, preferredHubId, onClose }) => {
  if (!target) return null;

  const contact = {
    id: target.contactId,
    name: target.contactName,
    messageable: true,
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content crm-order-whatsapp-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="crm-order-whatsapp-title"
      >
        <div className="modal-header crm-order-whatsapp-header">
          <div className="crm-order-whatsapp-heading">
            <span className="crm-order-whatsapp-mark" aria-hidden="true">W</span>
            <div>
              <div className="crm-call-eyebrow">CRM WhatsApp</div>
              <h3 id="crm-order-whatsapp-title">Message {target.contactName || 'customer'}</h3>
            </div>
          </div>
          <button type="button" className="modal-close" onClick={onClose} aria-label="Close WhatsApp dialog">×</button>
        </div>
        <div className="modal-body crm-order-whatsapp-body">
          <CrmWhatsappConversations
            leadId={target.leadId}
            hubLinks={target.hubLinks || []}
            preferredHubId={preferredHubId}
            contacts={[contact]}
            openContactId={target.contactId}
          />
        </div>
      </div>
    </div>
  );
};

export default CrmWhatsappDialog;
